import {Style} from '../../enum/style.enum';

export class DialogProgressManager {
  /**
   * Number of step to progress through
   */
  public max: number;
  /**
   * Style of progress bar
   */
  public style: Style;
  /**
   * State of progress
   */
  public progress: number;
  /**
   * Is the bar active ?
   */
  public isActive: boolean;

  constructor(max: number, style?: Style, initialProgress?: number) {
    this.max = max;
    this.style = style ?? Style.success;
    this.progress = initialProgress ?? 0;
    this.isActive = false;
  }
}
